var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-layout',{attrs:{"title":`${_vm.action} ${_vm.$tc('workOrder.name', 1)}`},on:{"submit":_vm.onSubmit}},[_c('v-form',{ref:"form"},[_c('TaskGroupEditForm',{staticClass:"mt-5",attrs:{"task-group":_vm.taskGroup}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }